// TODO it seems like the right approach would be to call this for Chart Trading as well as Trade Form trading -- not sure how hard that is
export default function SetDefaultValuesBasedOnStoredTpConfig(
  packageOfSetters,
  config,
  mutableSymbol
) {
  const [
    setStoredConfigKey,
    setConfigName,
    setRestartSettings,
    setTightSpreadPctEnabled,
    setTightSpreadCentsEnabled,
    setOptionPriceRangeEnabled,
    setQtyRangeEnabled,
    setDollarRangeEnabled,
    dispatchTightSpreadPct,
    dispatchTightSpreadCents,
    dispatchOptionPriceRange,
    dispatchQtyRange,
    dispatchDollarRange,
    setOptionChoices,
    setOptionChains,
    setHugCurrentPriceEnabled,
    setOtm1Enabled,
    setItm1Enabled,
    dispatchHugCurrentPrice,
    dispatchOtm1,
    dispatchItm1,
    setViewOptionManagementEnabled,
    setBuyOrSellOption,
    setOtm,
    setItm,
    setNotExpiringToday,
    dispatchTop,
    dispatchSetupDetails,
    setPriceIntersectsFirstCandleEnabled,
    dispatchPriceIntersectsFirstCandle,
    setEmaIntersectsFirstCandleEnabled,
    dispatchEmaIntersectsFirstCandle,
    setTimeOfDayEnabled,
    dispatchTimeOfDay,
    setFtfcFilterEnabled,
    dispatchFtfcFilter,
    setMarketOrderEnabled,
    setLimitOrderEnabled,
    setCandleBreakEnabled,
    dispatchMarketOrder,
    dispatchLimitOrder,
    dispatchCandleBreak,
    setScalingInEnabled,
    setAddToWinnerEnabled,
    dispatchScalingIn,
    dispatchAddToWinner,
    setLossLimitEnabled,
    setPreserveProfitEnabled,
    setPositionPriceTrailEnabled,
    setUnderlyingPriceTrailEnabled,
    setCandleTrailEnabled,
    setAtrTrailEnabled,
    setMfeRetracementEnabled,
    setGrabCentsEnabled,
    setRatchetBracketEnabled,
    setGreenToRedCandlesEnabled,
    setGreenToRedPositionsEnabled,
    setBreakPriceEnabled,
    setPositionBreakPriceEnabled,
    setCandleMagnitudeEnabled,
    setUnderlyingPriceExitEnabled,
    setGrabCentsMode,
    dispatchRatchetBracket,
    dispatchLossLimit,
    dispatchPreserveProfit,
    dispatchPositionPriceTrail,
    dispatchUnderlyingPriceTrail,
    dispatchCandleTrail,
    dispatchAtrTrail,
    dispatchMfeRetracement,
    dispatchGrabCents,
    dispatchGreenToRedCandles,
    dispatchGreenToRedPositions,
    dispatchBreakPrice,
    dispatchPositionBreakPrice,
    dispatchUnderlyingPriceExit,
    dispatchCandleMagnitude,
  ] = packageOfSetters;
  // if (config !== undefined && config.tradePlanJson !== undefined) {
  if (config !== undefined) {
    const tradePlanConfig = config; // config.tradePlanJson

    // setStoredConfigKey(config.key);
    // setConfigName(config.configurationName);
    //options
    /*
        ALL ELSES ARE DEFAULT STATE!
         */
    //  console.log("this version exits:");
    //  console.log(tradePlanConfig);
    if (tradePlanConfig.startPeriod !== undefined) {
      dispatchTop({ startPeriod: tradePlanConfig.startPeriod });
    } else {
      dispatchTop({ startPeriod: 'open' });
    }
    if (
      tradePlanConfig.startHour !== undefined &&
      tradePlanConfig.startMin !== undefined
    ) {
      //console.log("setting start min to: " + tradePlanConfig.startHour + ". and setting start min to: " + tradePlanConfig.startMin);
      dispatchTop({
        startHour: tradePlanConfig.startHour,
        startMin: tradePlanConfig.startMin,
      });
    } else {
      if (tradePlanConfig.startPeriod) {
        switch (tradePlanConfig.startPeriod) {
          case 'open':
            dispatchTop({
              startHour: 9,
              startMin: 30,
            });
            break;
          case 'premarket':
            dispatchTop({
              startHour: 8,
              startMin: 0,
            });
            break;
          case 'postmarket':
            dispatchTop({
              startHour: 16,
              startMin: 0,
            });
            break;
          default:
            break;
        }
      }
    }
    if (tradePlanConfig.restartSettings !== undefined) {
      setRestartSettings(tradePlanConfig.restartSettings);
    } else {
      setRestartSettings({
        maxRestartAttempts: 0,
        isMaxRestartAttempts: false,
        maxLoss: 0,
        isMaxLoss: false,
        maxMinutesInTradePlan: 0,
        isMaxMinutesInTradePlan: false,
        numberOfTrades: 0,
        isNumberOfTrades: false,
      });
    }
    if (tradePlanConfig.optionManagement !== undefined) {
      setViewOptionManagementEnabled(true);
      setNotExpiringToday(tradePlanConfig.optionManagement.notExpiringToday);
      let om = tradePlanConfig.optionManagement;
      setOtm(om.OTM);
      setItm(om.ITM);
      if (om.buyOrSellOption !== undefined) {
        setBuyOrSellOption(om.buyOrSellOption);
      } else {
        setBuyOrSellOption('LONG');
      }
      if (om.optionChainStrategy.hugCurrentPrice !== undefined) {
        setHugCurrentPriceEnabled(true);
        setOtm1Enabled(false);
        dispatchHugCurrentPrice(om.optionChainStrategy.hugCurrentPrice);
      } else {
        setHugCurrentPriceEnabled(true);
        dispatchHugCurrentPrice({ numOfStrikes: 5 });
      }
      if (om.optionChainStrategy.OTM1 !== undefined) {
        setOtm1Enabled(true);
        setHugCurrentPriceEnabled(false);
        dispatchOtm1(om.optionChainStrategy.OTM1);
      } else {
        setOtm1Enabled(false);
        dispatchOtm1({});
      }
      if (om.optionChainStrategy.ITM1 !== undefined) {
        setItm1Enabled(true);
        setHugCurrentPriceEnabled(false);
        dispatchItm1(om.optionChainStrategy.ITM1);
      } else {
        setItm1Enabled(false);
        dispatchItm1({});
      }
      if (om.optionFilters.tightSpreadPct !== undefined) {
        setTightSpreadPctEnabled(true);
        dispatchTightSpreadPct(om.optionFilters.tightSpreadPct);
      } else {
        setTightSpreadPctEnabled(false);
        dispatchTightSpreadPct({ maxOptionSpreadPct: 0.05 });
      }
      if (om.optionFilters.tightSpreadCents !== undefined) {
        setTightSpreadCentsEnabled(true);
        dispatchTightSpreadCents(om.optionFilters.tightSpreadCents);
      } else {
        setTightSpreadCentsEnabled(false);
        dispatchTightSpreadCents({ maxOptionSpreadCents: 0.0 });
      }
      if (om.optionFilters.optionPriceRange !== undefined) {
        setOptionPriceRangeEnabled(true);
        dispatchOptionPriceRange(om.optionFilters.optionPriceRange);
      } else {
        setOptionPriceRangeEnabled(false);
        dispatchOptionPriceRange({ minPrice: 0, maxPrice: 0 });
      }
      if (om.optionFilters.qtyRange !== undefined) {
        dispatchQtyRange(om.optionFilters.qtyRange);
        setQtyRangeEnabled(true);
      } else {
        setQtyRangeEnabled(false);
        dispatchQtyRange({ minQty: 0, maxQty: 0 });
      }
      if (om.optionFilters.dollarRange !== undefined) {
        dispatchDollarRange(om.optionFilters.dollarRange);
        setDollarRangeEnabled(true);
      } else {
        setDollarRangeEnabled(false);
        dispatchDollarRange({ minDollar: 0, maxDollar: 0 });
      }
    }
    if (tradePlanConfig.status !== undefined) {
      dispatchTop({ status: tradePlanConfig.status });
    } else {
      dispatchTop({ status: 'ARMED' });
    }
    if (tradePlanConfig.dataSource !== undefined) {
      dispatchTop({ dataSource: tradePlanConfig.dataSource });
    } else {
      dispatchTop({ dataSource: 'LIVE' });
    }
    if (tradePlanConfig.brokerage !== undefined) {
      dispatchTop({ brokerage: tradePlanConfig.brokerage });
    } else {
      dispatchTop({ brokerage: 'none' });
    }
    if (tradePlanConfig.accountNumber !== undefined) {
      dispatchTop({ accountNumber: tradePlanConfig.accountNumber });
    } else {
      dispatchTop({ accountNumber: 'none' });
    }
    if (tradePlanConfig.goLong !== undefined) {
      dispatchTop({ goLong: tradePlanConfig.goLong });
    } else {
      dispatchTop({ goLong: false });
    }
    if (tradePlanConfig.goShort !== undefined) {
      dispatchTop({ goShort: tradePlanConfig.goShort });
    } else {
      dispatchTop({ goShort: false });
    }
    if (tradePlanConfig.workOrders !== undefined) {
      dispatchTop({ workOrders: tradePlanConfig.workOrders });
    } else {
      dispatchTop({ workOrders: false });
    }
    if (tradePlanConfig.workOrdersOnEntry !== undefined) {
      dispatchTop({ workOrdersOnEntry: tradePlanConfig.workOrdersOnEntry });
    } else {
      dispatchTop({ workOrdersOnEntry: true });
    }
    if (tradePlanConfig.workOrdersOnExit !== undefined) {
      dispatchTop({ workOrdersOnExit: tradePlanConfig.workOrdersOnExit });
    } else {
      dispatchTop({ workOrdersOnExit: true });
    }
    if (tradePlanConfig.useDifferentWorkOrderFieldsOnExit !== undefined) {
      dispatchTop({
        useDifferentWorkOrderFieldsOnExit:
          tradePlanConfig.useDifferentWorkOrderFieldsOnExit,
      });
    } else {
      dispatchTop({ useDifferentWorkOrderFieldsOnExit: false });
    }
    if (tradePlanConfig.useDifferentWorkOrderFieldsOnTarget !== undefined) {
      dispatchTop({
        useDifferentWorkOrderFieldsOnTarget:
          tradePlanConfig.useDifferentWorkOrderFieldsOnTarget,
      });
    } else {
      dispatchTop({ useDifferentWorkOrderFieldsOnTarget: false });
    }

    if (tradePlanConfig.quantityBasis !== undefined) {
      dispatchTop({ quantityBasis: tradePlanConfig.quantityBasis });
    } else {
      dispatchTop({ quantityBasis: 'none' });
    }
    if (tradePlanConfig.flattenAtMarketClose !== undefined) {
      dispatchTop({
        flattenAtMarketClose: tradePlanConfig.flattenAtMarketClose,
      });
    } else {
      dispatchTop({ flattenAtMarketClose: false });
    }
    if (
      tradePlanConfig.persistTradePlanOnFailedFiltersOrValidation !== undefined
    ) {
      dispatchTop({
        persistTradePlanOnFailedFiltersOrValidation:
          tradePlanConfig.persistTradePlanOnFailedFiltersOrValidation,
      });
    } else {
      dispatchTop({ persistTradePlanOnFailedFiltersOrValidation: false });
    }

    if (tradePlanConfig.strategy !== undefined) {
      dispatchTop({ strategy: tradePlanConfig.strategy });
    } else {
      dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
    }
    if (tradePlanConfig.instrument !== undefined) {
      dispatchTop({ instrument: tradePlanConfig.instrument });
      setViewOptionManagementEnabled(tradePlanConfig.instrument === 'option');
    } else {
      dispatchTop({ instrument: 'none' });
    }
    if (tradePlanConfig.symbol !== undefined) {
      if (
        mutableSymbol.current !== tradePlanConfig.symbol &&
        tradePlanConfig.instrument === 'option'
      ) {
        setOptionChoices({});
        setOptionChains({});
      }
      dispatchTop({ symbol: tradePlanConfig.symbol });
      mutableSymbol.current = tradePlanConfig.symbol;
    } else {
      dispatchTop({ symbol: '' });
      mutableSymbol.current = '';
      if (tradePlanConfig.instrument === 'option') {
        setOptionChoices({});
        setOptionChains({});
      }
    }
    if (tradePlanConfig.evaluateQuotes !== undefined) {
      dispatchTop({ evaluateQuotes: tradePlanConfig.evaluateQuotes });
    } else {
      dispatchTop({ evaluateQuotes: true });
    }
    // if (tradePlanConfig.optionChoices !== undefined) {
    // dispatchTop({ optionChoices: tradePlanConfig.optionChoices });
    //}
    if (tradePlanConfig.setup !== undefined) {
      dispatchTop({ setup: tradePlanConfig.setup });
    } else {
      dispatchTop({ setup: 'none' });
    }
    if (tradePlanConfig.terminateWhenFlat !== undefined) {
      dispatchTop({ terminateWhenFlat: tradePlanConfig.terminateWhenFlat });
    } else {
      dispatchTop({ terminateWhenFlat: true });
    }
    if (tradePlanConfig.restartSystemOncePositionHasFlattened !== undefined) {
      //console.log(tradePlanConfig.restartSystemOncePositionHasFlattened);
      dispatchTop({
        restartSystemOncePositionHasFlattened:
          tradePlanConfig.restartSystemOncePositionHasFlattened,
      });
    } else {
      dispatchTop({ restartSystemOncePositionHasFlattened: false });
    }

    if (tradePlanConfig.getAwayOffsetPct !== undefined) {
      dispatchTop({ getAwayOffsetPct: tradePlanConfig.getAwayOffsetPct });
    } else {
      dispatchTop({ getAwayOffsetPct: 0.1 });
    }

    if (tradePlanConfig.getAwayOffsetPctOnExit !== undefined) {
      dispatchTop({
        getAwayOffsetPctOnExit: tradePlanConfig.getAwayOffsetPctOnExit,
      });
    } else {
      dispatchTop({ getAwayOffsetPctOnExit: 0.1 });
    }

    if (tradePlanConfig.getAwayOffsetPctOnTarget !== undefined) {
      dispatchTop({
        getAwayOffsetPctOnTarget: tradePlanConfig.getAwayOffsetPctOnTarget,
      });
    } else {
      dispatchTop({ getAwayOffsetPctOnTarget: 0.1 });
    }

    if (tradePlanConfig.pctBetweenBidAsk !== undefined) {
      dispatchTop({ pctBetweenBidAsk: tradePlanConfig.pctBetweenBidAsk });
    } else {
      dispatchTop({ pctBetweenBidAsk: 0.5 });
    }
    if (tradePlanConfig.pctBetweenBidAskOnExit !== undefined) {
      dispatchTop({
        pctBetweenBidAskOnExit: tradePlanConfig.pctBetweenBidAskOnExit,
      });
    } else {
      dispatchTop({ pctBetweenBidAskOnExit: 0.5 });
    }

    if (tradePlanConfig.pctBetweenBidAskOnTarget !== undefined) {
      dispatchTop({
        pctBetweenBidAskOnTarget: tradePlanConfig.pctBetweenBidAskOnTarget,
      });
    } else {
      dispatchTop({ pctBetweenBidAskOnTarget: 0.5 });
    }

    if (tradePlanConfig.pctIncreasePerOrderAttempt !== undefined) {
      dispatchTop({
        pctIncreasePerOrderAttempt: tradePlanConfig.pctIncreasePerOrderAttempt,
      });
    } else {
      dispatchTop({ pctIncreasePerOrderAttempt: 0.1 });
    }
    if (tradePlanConfig.pctIncreasePerOrderAttemptOnExit !== undefined) {
      dispatchTop({
        pctIncreasePerOrderAttemptOnExit:
          tradePlanConfig.pctIncreasePerOrderAttemptOnExit,
      });
    } else {
      dispatchTop({ pctIncreasePerOrderAttemptOnExit: 0.1 });
    }

    if (tradePlanConfig.pctIncreasePerOrderAttemptOnTarget !== undefined) {
      dispatchTop({
        pctIncreasePerOrderAttemptOnTarget:
          tradePlanConfig.pctIncreasePerOrderAttemptOnTarget,
      });
    } else {
      dispatchTop({ pctIncreasePerOrderAttemptOnTarget: 0.1 });
    }

    if (tradePlanConfig.setupDetails !== undefined) {
      if(tradePlanConfig.setupDetails.CANDLE_TRIGGER && !tradePlanConfig.setupDetails.CANDLE_TRIGGER.bounceOnGapFill) {
          tradePlanConfig.setupDetails.CANDLE_TRIGGER.bounceOnGapFill=false;
      }
      if(tradePlanConfig.setupDetails.CANDLE_PATTERN && !tradePlanConfig.setupDetails.CANDLE_PATTERN.evaluateLookBackOnStart) {
        tradePlanConfig.setupDetails.CANDLE_PATTERN.evaluateLookBackOnStart=false;
      }
      if(tradePlanConfig.setupDetails.CANDLE_PATTERN && !tradePlanConfig.setupDetails.CANDLE_PATTERN.evaluateLookBackOnRepeat) {
        tradePlanConfig.setupDetails.CANDLE_PATTERN.evaluateLookBackOnRepeat=false;
      }
      dispatchSetupDetails(tradePlanConfig.setupDetails[tradePlanConfig.setup]);    
    } else {
      dispatchSetupDetails({});
    }
    //setup filters
    if (tradePlanConfig.setupFilters !== undefined) {
      if (
        tradePlanConfig.setupFilters.PRICE_INTERSECTS_FIRST_CANDLE !== null &&
        tradePlanConfig.setupFilters.PRICE_INTERSECTS_FIRST_CANDLE !== undefined
      ) {
        setPriceIntersectsFirstCandleEnabled(true);
        dispatchPriceIntersectsFirstCandle(
          tradePlanConfig.setupFilters.PRICE_INTERSECTS_FIRST_CANDLE
        );
      } else {
        setPriceIntersectsFirstCandleEnabled(false);
        dispatchPriceIntersectsFirstCandle({ candleDuration: 15 });
      }
      if (
        tradePlanConfig.setupFilters.EMA_INTERSECTS_FIRST_CANDLE !== null &&
        tradePlanConfig.setupFilters.EMA_INTERSECTS_FIRST_CANDLE !== undefined
      ) {
        setEmaIntersectsFirstCandleEnabled(true);
        dispatchEmaIntersectsFirstCandle(
          tradePlanConfig.setupFilters.EMA_INTERSECTS_FIRST_CANDLE
        );
      } else {
        setEmaIntersectsFirstCandleEnabled(false);
        dispatchEmaIntersectsFirstCandle({
          firstCandleCandleDuration: 15,
          emaCandleDuration: 0,
          periodLengths: [],
          associatePerEmaSetup: false,
        });
      }
      if (
        tradePlanConfig.setupFilters.TIME_OF_DAY !== null &&
        tradePlanConfig.setupFilters.TIME_OF_DAY !== undefined
      ) {
        setTimeOfDayEnabled(true);
        dispatchTimeOfDay(tradePlanConfig.setupFilters.TIME_OF_DAY);
      } else {
        setTimeOfDayEnabled(false);
        dispatchTimeOfDay({
          startHour: 0,
          startMinute: 0,
          endHour: 0,
          endMinute: 0,
        });
      }
      if (
        tradePlanConfig.setupFilters.FTFC !== null &&
        tradePlanConfig.setupFilters.FTFC !== undefined
      ) {
        setFtfcFilterEnabled(true);
        dispatchFtfcFilter(tradePlanConfig.setupFilters.FTFC);
      } else {
        setFtfcFilterEnabled(false);
        dispatchFtfcFilter({ timeFrames: [] });
      }
    } else {
      setEmaIntersectsFirstCandleEnabled(false);
      dispatchEmaIntersectsFirstCandle({
        firstCandleCandleDuration: 15,
        emaCandleDuration: 0,
        periodLengths: [],
        associatePerEmaSetup: false,
      });
      setPriceIntersectsFirstCandleEnabled(false);
      dispatchPriceIntersectsFirstCandle({ candleDuration: 15 });
      setTimeOfDayEnabled(false);
      dispatchTimeOfDay({
        startHour: 0,
        startMinute: 0,
        endHour: 0,
        endMinute: 0,
      });
      setFtfcFilterEnabled(false);
      dispatchFtfcFilter({ timeFrames: [] });
    }
    // Entry Tactics
    if (tradePlanConfig.entryTactics !== undefined) {
      if (tradePlanConfig.entryTactics.MARKET_ORDER !== undefined) {
        console.log(
          'setting to mo: ' +
            JSON.stringify(tradePlanConfig.entryTactics.MARKET_ORDER)
        );
        setMarketOrderEnabled(true);
        dispatchMarketOrder(tradePlanConfig.entryTactics.MARKET_ORDER);
      } else {
        setMarketOrderEnabled(false);
        dispatchMarketOrder({ quantityBasisValue: 0 });
      }
      if (tradePlanConfig.entryTactics.LIMIT_ORDER !== undefined) {
        setLimitOrderEnabled(true);
        dispatchLimitOrder(tradePlanConfig.entryTactics.LIMIT_ORDER);
      } else {
        setLimitOrderEnabled(false);
        dispatchLimitOrder({
          offsetFromSetupPrice: 0,
          quantityBasisValue: 0,
          setLimitFromSetupBreakPrice: false,
          limitPrice: 0,
        });
      }
      if (tradePlanConfig.entryTactics.CANDLE_BREAK !== undefined) {
        setCandleBreakEnabled(true);
        dispatchCandleBreak(tradePlanConfig.entryTactics.CANDLE_BREAK);
      } else {
        setCandleBreakEnabled(false);
        dispatchCandleBreak({
          candleDuration: 1,
          quantityBasisValue: 0,
          waitUntilCurrentCandleCloses: false,
        });
      }
    } else {
      setMarketOrderEnabled(false);
      dispatchMarketOrder({ quantityBasisValue: 0 });
      setLimitOrderEnabled(false);
      dispatchLimitOrder({
        offsetFromSetupPrice: 0,
        quantityBasisValue: 0,
        setLimitFromSetupBreakPrice: false,
      });
      setCandleBreakEnabled(false);
      dispatchCandleBreak({
        candleDuration: 1,
        quantityBasisValue: 0,
        waitUntilCurrentCandleCloses: false,
      });
    }
    // Position Tactics
    if (tradePlanConfig.positionTactics !== undefined) {
      if (tradePlanConfig.positionTactics.SCALING_IN !== undefined) {
        setScalingInEnabled(true);
        dispatchScalingIn(tradePlanConfig.positionTactics.SCALING_IN);
      } else {
        setScalingInEnabled(false);
        dispatchScalingIn({ quantityBasisValues: [], breakPrices: [] });
      }
      if (tradePlanConfig.positionTactics.ADD_TO_WINNER !== undefined) {
        setAddToWinnerEnabled(true);
        dispatchAddToWinner(tradePlanConfig.positionTactics.ADD_TO_WINNER);
      } else {
        setAddToWinnerEnabled(false);
        dispatchAddToWinner({ quantityBasisValues: [], breakPrices: [] });
      }
    } else {
      setScalingInEnabled(false);
      dispatchScalingIn({ quantityBasisValues: [], breakPrices: [] });
      setAddToWinnerEnabled(false);
      dispatchAddToWinner({ quantityBasisValues: [], breakPrices: [] });
    }
    //Exit Tactics
    if (tradePlanConfig.exitTactics !== undefined) {
      let et = tradePlanConfig.exitTactics;
      //console.log("attempting to check loss limit");
      //console.log(JSON.stringify(et.LOSS_LIMIT));
      if (et.LOSS_LIMIT !== undefined) {
        setLossLimitEnabled(true);
        dispatchLossLimit(et.LOSS_LIMIT);
      } else {
        setLossLimitEnabled(false);
        dispatchLossLimit({ amount: 0 });
      }
      if (et.PRESERVE_PROFIT !== undefined) {
        setPreserveProfitEnabled(true);
        dispatchPreserveProfit(et.PRESERVE_PROFIT);
      } else {
        setPreserveProfitEnabled(false);
        dispatchPreserveProfit({ amount: 0 });
      }
      if (et.POSITION_PRICE_TRAIL !== undefined) {
        setPositionPriceTrailEnabled(true);
        dispatchPositionPriceTrail(et.POSITION_PRICE_TRAIL);
      } else {
        setPositionPriceTrailEnabled(false);
        dispatchPositionPriceTrail({ amount: 0 });
      }
      if (et.UNDERLYING_PRICE_EXIT !== undefined) {
        setUnderlyingPriceExitEnabled(true);
        dispatchUnderlyingPriceExit(et.UNDERLYING_PRICE_EXIT);
      } else {
        setUnderlyingPriceExitEnabled(false);
        dispatchUnderlyingPriceExit({ underlyingPricePairs: [] });
      }

      if (et.RATCHET_BRACKET !== undefined) {
        setRatchetBracketEnabled(true);
        dispatchRatchetBracket(et.RATCHET_BRACKET);
      } else {
        setRatchetBracketEnabled(false);
        dispatchRatchetBracket({});
      }

      if (et.UNDERLYING_PRICE_TRAIL !== undefined) {
        setUnderlyingPriceTrailEnabled(true);
        dispatchUnderlyingPriceTrail(et.UNDERLYING_PRICE_TRAIL);
      } else {
        setUnderlyingPriceTrailEnabled(false);
        dispatchUnderlyingPriceTrail({ amount: 0 });
      }
      if (et.CANDLE_TRAIL !== undefined) {
        setCandleTrailEnabled(true);
        if (et.CANDLE_TRAIL.timeUnit === undefined) {
          et.CANDLE_TRAIL.timeUnit = 'MINUTES';
        }
        dispatchCandleTrail(et.CANDLE_TRAIL);
      } else {
        setCandleTrailEnabled(false);
        dispatchCandleTrail({
          candleDuration: 1,
          usePrePostMarketData: false,
          timeUnit: 'MINUTES',
        });
      }
      if (et.ATR_TRAIL !== undefined) {
        setAtrTrailEnabled(true);
        dispatchAtrTrail(et.ATR_TRAIL);
      } else {
        setAtrTrailEnabled(false);
        dispatchAtrTrail({
          pctOfAtr: 1, //default is 1 whole ATR
          ATR: {
            candlesBack: 14, //field # of candles
            atrType: 'WILDER', //options: SMA, WILDER, SMA_NO_GAP. drop down. wilder used 90% of time
            candleDuration: 1, //do candle duration + time unit combo
            timeUnit: 'MINUTES',
          },
        });
      }
      if (et.MFE_RETRACEMENT !== undefined) {
        setMfeRetracementEnabled(true);
        dispatchMfeRetracement(et.MFE_RETRACEMENT);
      } else {
        setMfeRetracementEnabled(false);
        dispatchMfeRetracement({
          mfeType: 'byPositionPrice', //drop down options: byPositionPrice, byPnl
          retraceType: 'expanding', //dont show to users, this is for future implementations
          activateSetting: 'PERCENT', //options: PERCENT, AMOUNT. notes: If mfeType === position price, this must be a percentage. if mfeType==byPnl, this can be either pct or amount
          pnlType: 'OVERALL', //options: OVERALL, UNREALIZED. notes: only selectable if mfeType===byPnl
          retracePct: 0, //pct to retrace from max mfe
          activationValue: 0,
        });
      }
      if (et.GREEN_TO_RED_CANDLES !== undefined) {
        setGreenToRedCandlesEnabled(true);
        if (et.GREEN_TO_RED_CANDLES.timeUnit === undefined) {
          et.GREEN_TO_RED_CANDLES.timeUnit = 'MINUTES';
        }
        dispatchGreenToRedCandles(et.GREEN_TO_RED_CANDLES);
      } else {
        setGreenToRedCandlesEnabled(false);
        dispatchGreenToRedCandles({
          candleDuration: 1,
          inRightDirectionPct: 0,
          retracePct: 0.4,
          minCandleHeight: 0.5,
          timeUnit: 'MINUTES',
        });
      }
      if (et.GREEN_TO_RED_POSITIONS !== undefined) {
        setGreenToRedPositionsEnabled(true);
        if(!et.GREEN_TO_RED_POSITIONS.pnlTracking || et.GREEN_TO_RED_POSITIONS.pnlTracking==="unrealized") {
          et.GREEN_TO_RED_POSITIONS.pnlTracking="overall";
        }
        dispatchGreenToRedPositions(et.GREEN_TO_RED_POSITIONS);
      } else {
        setGreenToRedPositionsEnabled(false);
        dispatchGreenToRedPositions({ inRightDirectionPct: 0, retracePct: 0 });
      }
      if (et.BREAK_PRICE !== undefined) {
        setBreakPriceEnabled(true);
        dispatchBreakPrice(et.BREAK_PRICE);
      } else {
        setBreakPriceEnabled(false);
        dispatchBreakPrice({ prices: [] });
      }
      if (et.POSITION_BREAK_PRICE !== undefined) {
        setPositionBreakPriceEnabled(true);
        dispatchPositionBreakPrice(et.POSITION_BREAK_PRICE);
      } else {
        setPositionBreakPriceEnabled(false);
        dispatchPositionBreakPrice({ prices: [] });
      }
      if (et.CANDLE_MAGNITUDE !== undefined) {
        setCandleMagnitudeEnabled(true);
        dispatchCandleMagnitude(et.CANDLE_MAGNITUDE);
      } else {
        setCandleMagnitudeEnabled(false);
        dispatchCandleMagnitude({
          candleDuration: 1,
          numberOfPivots: 0,
          qtyPctPerPivot: [],
          exitInPivotCandle: 'high_low',
          usePivotsAsTrails: false,
          filterInsideCandleMagnitudes: false,
          timeUnit: 'MINUTES',
        });
      }
      if (et.GRAB_CENTS !== undefined) {
        setGrabCentsEnabled(true);
        let grabCentsTactic = et.GRAB_CENTS;
        if (grabCentsTactic.takeProfitMode === undefined) {
          grabCentsTactic.takeProfitMode = 'DOLLARS';
        }
        setGrabCentsMode(
          grabCentsTactic.quantityPerLevel !== undefined
            ? 'quantity'
            : 'percentage'
        );
        dispatchGrabCents(et.GRAB_CENTS);
      } else {
        setGrabCentsEnabled(false);
        setGrabCentsMode('quantity');
        dispatchGrabCents({
          quantityPerLevel: [],
          percentagePerLevel: [],
          trailQuantity: 0,
          trailPercent: 0,
          centsPerLevel: [],
          trailAmount: 0,
          takeProfitMode: 'DOLLARS',
        });
      }
    } else {
      setLossLimitEnabled(false);
      dispatchLossLimit({ amount: 0 });
      setPreserveProfitEnabled(false);
      dispatchPreserveProfit({ amount: 0 });
      setPositionPriceTrailEnabled(false);
      dispatchPositionPriceTrail({ amount: 0 });
      setUnderlyingPriceTrailEnabled(false);
      dispatchUnderlyingPriceTrail({ amount: 0 });
      setCandleTrailEnabled(false);
      dispatchCandleTrail({ candleDuration: 1, usePrePostMarketData: false });
      setGreenToRedCandlesEnabled(false);
      dispatchGreenToRedCandles({
        candleDuration: 1,
        inRightDirectionPct: 0,
        retracePct: 0.4,
        minCandleHeight: 0.5,
      });
      setGreenToRedPositionsEnabled(false);
      dispatchGreenToRedPositions({ inRightDirectionPct: 0, retracePct: 0 });
      setBreakPriceEnabled(false);
      setPositionBreakPriceEnabled(false);
      dispatchBreakPrice({ prices: [] });
      dispatchPositionBreakPrice({ prices: [] });
      setGrabCentsEnabled(false);
      setGrabCentsMode('quantity');
      dispatchGrabCents({
        quantityPerLevel: [],
        percentagePerLevel: [],
        trailQuantity: 0,
        trailPercent: 0,
        centsPerLevel: [],
        trailAmount: 0,
      });
    }
  }
}
